import { loginApi } from "src/api/taktileApi";

export const loginWithRefreshToken = async () => {
  return (await loginApi.authRefreshApiV1LoginRefreshPost()).data;
};

export const loginWithWorkspaceScope = async (
  organizationId: string,
  workspaceId: string,
  options?: { signal?: AbortSignal },
) => {
  return (
    await loginApi.loginAccessTokenApiV1LoginAccessTokenPost(
      undefined, // expiresSeconds
      organizationId,
      workspaceId,
      undefined, // roles
      undefined, // host
      options,
    )
  ).data;
};

/**
 * Mint an (org, ws)-scoped id_token WITHOUT applying it to the session. Used to
 * read a cross-workspace source (e.g. copy-from-template) while the session
 * token is scoped to another workspace.
 */
export const mintSourceToken = async (
  organizationId: string,
  workspaceId: string,
): Promise<string> => {
  return (
    await loginApi.loginAccessTokenApiV1LoginAccessTokenPost(
      undefined,
      organizationId,
      workspaceId,
    )
  ).data.id_token;
};
